import React from "react";
import { Link } from "gatsby";
import Url from "~/models/url";

interface BreadcrumbsProps {
  urls: Url[];
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ urls, className = "" }) => {
  if (!urls || urls.length === 0) {
    return null;
  }

  return (
    <nav
      className={`flex flex-col gap-2.5 items-center w-full ${className}`}
      aria-label="Breadcrumb"
    >
      <div className="flex gap-[9px] items-center py-10 w-full px-container">
        {urls.map((url, index) => (
          <React.Fragment key={url.id}>
            {index === urls.length - 1 ? (
              // Last item (current page) - not a link
              <span className="font-normal text-sm text-black tracking-[-0.28px] font-base">
                {url.name}
              </span>
            ) : (
              // Breadcrumb link
              <Link
                to={url.pathname}
                className="font-normal text-sm text-black tracking-[-0.28px] hover:text-neutral-40 transition-colors font-base"
              >
                {url.name}
              </Link>
            )}

            {/* Arrow separator (not shown after last item) */}
            {index < urls.length - 1 && (
              <img
                src="/images/breadcrumb-arrow.svg"
                alt=""
                className="w-4 h-4"
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
